import CryptoJS from 'crypto-js';

const SECRET_KEY = 'suyog-key'; // 🔐 Use an env var or hard-to-guess key in real apps

export const encryptData = (data) => {
  const stringData = JSON.stringify(data);
  return CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
};

export const decryptData = (cipherText) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};
